import axios from 'axios';

const api = '/api/contract-documents';

export const uploadDocument = (contractId, file) => {
  const formData = new FormData();
  formData.append('contractId', contractId);
  formData.append('file', file);

  return axios.post(`${api}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const downloadDocument = async contractDocument => {
  const response = await axios.get(`${api}/download/${contractDocument.id}`, {
    responseType: 'blob', // Important for binary data
  });

  // Create a URL for the blob
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', contractDocument.originalFilename); // Set the original file name
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const fetchDocumentBlob = async (documentId): Promise<{ url: string; mimeType: string }> => {
  const response = await axios.get(`${api}/download/${documentId}`, {
    responseType: 'blob',
  });
  const mimeType = response.data?.type || response.headers?.['content-type'] || 'application/octet-stream';
  const url = window.URL.createObjectURL(new Blob([response.data], { type: mimeType }));
  return { url, mimeType };
};

export const deleteDocumentById = contractDocument => {
  return axios.delete(`${api}/${contractDocument.id}`);
};
